import { jsx as L } from "react/jsx-runtime";
function i(t) {
  return /* @__PURE__ */ L("svg", { fill: "none", height: "10px", viewBox: "0 0 10 9", width: "12px", xmlns: "http://www.w3.org/2000/svg", ...t, children: /* @__PURE__ */ L(
    "path",
    {
      d: "M0.556215 1.24261L1.64201 0.15681L4.89941 3.4142L8.15681 0.156809L9.24261 1.24261L5.98521 4.5L9.24261 7.7574L8.15681 8.84319L4.89941 5.5858L1.64201 8.84319L0.556214 7.7574L3.81361 4.5L0.556215 1.24261Z",
      fill: "#00182E"
    }
  ) });
}
export {
  i as default
};
